<!--  KÉZBESÍTÉSI NAPLÓ. Egy helyen, csatornától függetlenül: hol tart a kiküldött irat. -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Kézbesítési napló</ion-card-title>
    <ion-card-subtitle>
      Küldeményenként az <b>életút</b>: mikor ment el, jött-e feladási igazolás, mikor töltötte le a címzett.
      A hivatali kapun az <b>igazolás a kézbesítés bizonyítéka</b> – itt egy kattintással megnyitható, és
      alszámként az eredeti irat ügyiratán is ott van. A Sulinformból küldött üzenetek is itt látszanak.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor" style="align-items:flex-end; flex-wrap:wrap; gap:10px">
      <ion-segment [(ngModel)]="forras" (ionChange)="betolt()" mode="ios" style="max-width:640px">
        <ion-segment-button *ngFor="let f of forrasok" [value]="f.kulcs">{{ f.nev }}</ion-segment-button>
      </ion-segment>
      <ion-searchbar class="ikt-kereso" placeholder="Címzett, tárgy, iktatószám, érkeztetési szám…" mode="md"
                     [(ngModel)]="kereses" (ionInput)="keresesValtozott()" (ionClear)="keresesValtozott()"
                     [debounce]="0"></ion-searchbar>
      <ion-select label="Időszak" label-placement="stacked" interface="popover" style="max-width:150px"
                  [(ngModel)]="napok" (ionChange)="betolt()">
        <ion-select-option [value]="30">30 nap</ion-select-option>
        <ion-select-option [value]="90">90 nap</ion-select-option>
        <ion-select-option [value]="365">1 év</ion-select-option>
        <ion-select-option [value]="3650">minden</ion-select-option>
      </ion-select>
      <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="toltodik">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
      </ion-button>
    </div>

    <div style="overflow-x:auto" *ngIf="kuldemenyek.length; else nincs">
      <table class="ikt-tabla">
        <thead>
          <tr><th></th><th>Küldemény</th><th>Címzett</th><th>Csatorna</th><th>Állapot</th><th>Életút</th></tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let k of kuldemenyek">
            <tr>
              <td style="width:32px">
                <ion-button size="small" fill="clear" (click)="nyit(k)" *ngIf="k.esemenyek?.length">
                  <ion-icon slot="icon-only" [name]="nyitott[k.kulcs] ? 'chevron-down' : 'chevron-forward'"></ion-icon>
                </ion-button>
              </td>
              <td>
                <a *ngIf="k.irat" href="javascript:void(0)" (click)="iratra(k)">{{ k.iktatoszam || 'irat' }}</a>
                <span *ngIf="!k.irat && k.forras === 'uzenet'">üzenet</span>
                <br><small>{{ k.targy || '–' }}</small>
              </td>
              <td>{{ k.cimzett || '–' }}
                <br><small *ngIf="k.azonosito">{{ k.azonosito }}</small>
                <br><small *ngIf="k.forras === 'uzenet'">{{ k.olvasta_db }} / {{ k.cimzett_db }} elolvasta</small>
              </td>
              <td>{{ forrasNev(k.forras) }}</td>
              <td>
                <ion-badge [color]="allapotSzin(k)">{{ allapotNev(k) }}</ion-badge>
                <br><small *ngIf="k.hiba" style="color:var(--ion-color-danger)">{{ k.hiba }}</small>
              </td>
              <td>
                <span *ngIf="!k.esemenyek?.length" style="color:var(--ion-color-medium)">nincs esemény</span>
                <span *ngFor="let e of k.esemenyek" class="kezb-pont">
                  <ion-badge [color]="esemenySzin(e)">{{ e.nev }}</ion-badge>
                  <small>{{ e.ideje }}</small>
                </span>
              </td>
            </tr>
            <!--  Részletek: az egyes események, és a bizonyító igazolás megnyitása. -->
            <tr *ngIf="nyitott[k.kulcs]" class="kezb-reszletek">
              <td colspan="6">
                <div *ngFor="let e of k.esemenyek" class="kezb-sor">
                  <ion-badge [color]="esemenySzin(e)">{{ e.nev }}</ion-badge>
                  <span class="kezb-ido">{{ e.ideje }}</span>
                  <span *ngIf="e.megjegyzes">{{ e.megjegyzes }}</span>
                  <span *ngIf="e.azonosito" class="kezb-azon">{{ e.azonosito }}</span>
                  <ion-button size="small" fill="clear" *ngIf="e.bejovo" (click)="igazolasNyit(e)">
                    <ion-icon slot="start" name="document-attach-outline"></ion-icon>
                    {{ e.igazolas_fajl || 'igazolás megnyitása' }}
                  </ion-button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <ng-template #nincs>
      <p style="font-size:.85rem; color:var(--ion-color-medium)">
        {{ kereses ? 'Erre a keresésre nincs találat.' : 'Ebben az időszakban nincs küldemény.' }}
      </p>
    </ng-template>
  </ion-card-content>
</ion-card>
